var e=function(e,r){return Object.keys(e).reduce((function(t,c){var n=e[c];return t[c]=n.label,"metrics"in n&&(t[c]+=" (".concat(r[n.metrics],")")),t}),{})};export{e as default};
